import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { ShieldAlert } from "lucide-react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../components/ui/tabs";
import { useAuthedApi } from "../lib/api";
import Overview from "../components/admin/Overview";
import AdminListings from "../components/admin/AdminListings";
import AdminDealers from "../components/admin/AdminDealers";
import AdminLeads from "../components/admin/AdminLeads";
import AdminUsers from "../components/admin/AdminUsers";
import AdminBanners from "../components/admin/AdminBanners";
import AdminHero from "../components/admin/AdminHero";
import AdminFilters from "../components/admin/AdminFilters";

const TABS = [["overview", "Overview"], ["hero", "Homepage Banners"], ["listings", "Listings"], ["banners", "City Banners"], ["filters", "Filters"], ["dealers", "Dealers & Verification"], ["leads", "Enquiries & Offers"], ["users", "Users"]];

export default function Admin() {
  const api = useAuthedApi();
  const [params, setParams] = useSearchParams();
  const [me, setMe] = useState(null);
  const tab = params.get("tab") || "overview";
  useEffect(() => { api("get", "/me").then(setMe).catch(() => setMe({ role: "none" })); }, [api]);

  if (!me) return <div className="pt-40 text-center text-gray-500">Loading...</div>;
  if (me.role !== "admin") return (
    <div className="pt-40 max-w-md mx-auto text-center space-y-4" data-testid="admin-forbidden">
      <ShieldAlert className="w-12 h-12 text-[#D4AF37] mx-auto" />
      <h1 className="font-display text-4xl">Admins only</h1>
      <p className="text-gray-400">This area is reserved for the site owner.</p>
      <Link to="/" className="btn-outline">Back to home</Link>
    </div>
  );

  const trig = "data-[state=active]:text-black data-[state=active]:bg-[#D4AF37] rounded-full px-4 py-2 text-xs sm:text-sm text-gray-300";
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-32" data-testid="admin-page">
      <p className="eyebrow mb-3">Owner console · {me.email}</p>
      <h1 className="font-display text-5xl sm:text-6xl mb-10">Admin Panel</h1>
      <Tabs value={tab} onValueChange={(v) => setParams({ tab: v })}>
        <TabsList className="bg-[#111319] border gold-line rounded-full p-1 h-auto flex-wrap justify-start mb-8">
          {TABS.map(([v, l]) => <TabsTrigger key={v} value={v} className={trig} data-testid={`admin-tab-${v}`}>{l}</TabsTrigger>)}
        </TabsList>
        <TabsContent value="overview"><Overview onGo={(t) => setParams({ tab: t })} /></TabsContent>
        <TabsContent value="listings"><AdminListings /></TabsContent>
        <TabsContent value="banners"><AdminBanners /></TabsContent>
        <TabsContent value="hero"><AdminHero /></TabsContent>
        <TabsContent value="filters"><AdminFilters /></TabsContent>
        <TabsContent value="dealers"><AdminDealers /></TabsContent>
        <TabsContent value="leads"><AdminLeads /></TabsContent>
        <TabsContent value="users"><AdminUsers /></TabsContent>
      </Tabs>
    </div>
  );
}
